export const userRole = user => user?.role === 'super_admin' || user?.is_superuser === true ? 'super_admin'
  : user?.role === 'admin' || user?.is_admin === true ? 'admin' : 'user';
export const roleLabel = user => ({ super_admin: '超级管理员', admin: '管理员', user: '普通用户' })[userRole(user)] || '普通用户';

const canTargetAccount = (actor, target) => Boolean(actor?.id && target?.id)
  && actor.is_active !== false && String(actor.id) !== String(target.id)
  && userRole(target) !== 'super_admin';
const allowsAction = (target, action) => !Array.isArray(target?.allowed_actions) || target.allowed_actions.includes(action);

// 服务端动作列表只能收紧权限，旧列表不能绕过自身和管理员层级保护。
export const canManageAccount = (actor, target) => canTargetAccount(actor, target)
  && ['admin', 'super_admin'].includes(userRole(actor))
  && (userRole(actor) === 'super_admin' || (userRole(target) === 'user' && !target.is_staff))
  && allowsAction(target, target.is_active === false ? 'unfreeze' : 'freeze');
export const canManageRole = (actor, target) => canTargetAccount(actor, target)
  && userRole(actor) === 'super_admin'
  && allowsAction(target, userRole(target) === 'admin' ? 'revoke-admin' : 'grant-admin');
